<template>
  <div class="wrapper">
    <div class="container">
      <Tinder ref="tinder" key-name="id" :queue.sync="queue" :offset-y="10" @submit="onSubmit" :allowSuper="false"
        :pointerThreshold="threshold">
        <template slot-scope="scope">

          <div v-if="scope.data.id === 'INFO'" class="infobox">
            <div class="info">
              <div style="display:flex;align-items:center">
                <h3 style="flex-grow:1">
                  Infos
                </h3>
                <mdicon :size="40" name="information-outline" class="infoicon" />
              </div>

              <div class="inforow" v-for="item in infos" :key="item.icon">
                <mdicon :size="25" :name="item.icon" />
                <div>{{ item.first }}
                  <span v-if="!!item.second" class="secondline"><br />{{ item.second }}</span>
                </div>
              </div>


            </div>
            <div class="signup" @click="signup()">Ja, ich will!<br /><span style="font-size:0.8rem">...mit euch
                feiern.</span>
            </div>
          </div>

          <div v-else-if="scope.data.id === 'MUSIC'" class="pic-wrapper" :style="{
            'background-image': `url(/fotos/${scope.data.id}.jpg)`
          }">
            <video playsinline ref="video" class="video-js vjs-defaultskin"></video>
            <div class="card-text-wrapper" style="position:absolute">
              <div class="card-text">
                <h1 v-html="scope.data.title"></h1>
                <h2>{{ scope.data.subtitle }}</h2>
                <span class="text" v-html="scope.data.text"></span>
              </div>
            </div>
          </div>

          <div v-else class="pic-wrapper" :style="{
            'background-image': `url(/fotos/${scope.data.id}.jpg)`
          }">
            <div class="card-text-wrapper">
              <div class="card-text">
                <h1 v-html="scope.data.title"></h1>
                <h2>{{ scope.data.subtitle }}</h2>
                <span class="text" v-html="scope.data.text"></span>
              </div>
            </div>
          </div>
        </template>
      </Tinder>
      <div class="btns-wrapper">
        <div class="btns">
          <img class="small" src="./assets/rewind.png" @click="decide('rewind')">
          <img :class="{ hidden: this.queue[0].final }" class="big" src="./assets/nope.png" @click="decide('nope')">

          <img :class="{ hidden: this.queue[0].final }" class="big" src="./assets/like.png" @click="decide('like')">
          <img :class="{ hidden: this.queue[0].id == 'INFO' }" class="small" src="./assets/info.png"
            @click="decide('info')">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tinder from "vue-tinder";
import videojs from 'video.js';

const STATES = {
  WELCOME: {
    id: 'WELCOME',
    title: 'Kusi&nbsp;&nbsp;❤️&nbsp;&nbsp;Vivi&nbsp;&nbsp<span style="font-size:1.2rem; font-weight:normal">67</span>',
    subtitle: '📍 46 km entfernt',
    text: 'Am 22.11.22 haben wir geheiratet - dies möchten wir mit euch feiern! Seid ihr dabei? Swipe nach rechts! &raquo;',
    final: false
  },
  YES: {
    id: 'YES',
    title: '🥳&nbsp;&nbsp;IT\'S A MATCH!',
    text: 'Wir freuen uns riesig darauf, mit euch zu feiern! 🎉 Let\'s party! &raquo;',
    final: false
  },
  LOCATION: {
    id: 'LOCATION',
    title: '📍&nbsp;&nbsp;Wie, wo, wann?',
    text: 'Am 29. April 2023 seid ihr herzlich eingeladen ab 15 Uhr mit uns in der Braustation Sursee anzustossen. 🍻🥂 Anschliessend heizen wir den Grill ein, lassen uns kulinarisch verwöhnen und geniessen zusammen den Abend! 🍖🫑',
    final: false
  },
  DRESSCODE: {
    id: 'DRESSCODE',
    title: '👗&nbsp;&nbsp;Was ziehe ich an?',
    text: 'Wissen wir auch nicht - einen Dresscode gibt es nicht. Kommt einfach so, wie ihr euch wohlfühlt! Vivi wird sowieso die Schönste sein. 👰🏻‍♀️',
    final: false
  },
  GIFT: {
    id: 'GIFT',
    title: '🎁&nbsp;&nbsp;Geschenke',
    text: 'Mit euch zu feiern ist unser grösstes Geschenk! Falls ihr uns dennoch etwas schenken möchtet, freuen wir uns über einen Zustupf ins Reisekässeli. 💰<br /><span style="font-size:0.5rem">...oder ihr macht Wanda ein Geschenk und flickt eine ihrer Roststellen!</span>',
    final: false
  },
  TZ: {
    id: 'TZ',
    title: '🤵🏻‍♀️&nbsp;&nbsp;Trauzeuginnen&nbsp;&nbsp;🤵🏼‍♀️',
    text: 'Die Frauen unseres Vertrauens!<br />Meldet euch bis Ende März bei ihnen, wenn ihr unser Fest mitgestalten möchtet.<div style="margin-top:0.4rem;line-height:1.3rem;">☎️ Maria-Rosa 078 956 15 28 <br /> ☎️ Seraina 079 871 57 69</div>',
    final: false
  },
  MUSIC: {
    id: 'MUSIC',
    title: '🎶🎷&nbsp;&nbsp;Wir lieben Musik',
    text: 'Gibt es ein Lied, das ihr mit uns verbindet? Oder vielleicht eine Band? Schickt uns diese Lieder - sie dürfen an unserem Fest nicht fehlen!',
    final: false
  },
}

const INFO = {
  id: 'INFO',
  final: true
};

// final
const OHNO = {
  id: 'OHNO',
  title: 'Schade... 😢',
  text: 'Falls ihr euch doch noch umentscheidet, könnt ihr euch noch bis Ende Februar 2023 anmelden.<br /><span style="font-size:10px">Mit dem gelben Knopf geht\'s zurück zum Anfang.</span>',
  final: true
}

const INFOS = [{
  icon: 'calendar-month',
  first: '29. April 2023',
  second: ''

},
{
  icon: 'clock-time-three-outline',
  first: '15:00 bis ??',
  second: ''

},
{
  icon: 'map-marker-outline',
  first: 'Braustation',
  second: 'Merkurstrasse 20, 6210 Sursee'

},
{
  icon: 'car-back',
  first: 'Parkplätze vorhanden',
  second: ''

},
{
  icon: 'bed',
  first: 'Übernachten',
  second: 'Es gibt einige Unterkünfte in Sursee. Wir helfen euch gerne weiter.'

}]

export default {
  name: "App",
  components: { Tinder },
  data: () => ({
    queue: [],
    infos: INFOS,
    player: null
  }),

  computed: {
    threshold() {
      return this.queue[0].final ? 5 : 0.5;
    }
  },

  created() {
    this.populate();
  },
  methods: {
    populate() {
      const list = [];
      for (const curState in STATES) {
        list.push(STATES[curState]);
      }
      list.push(INFO);
      this.queue = list;
    },

    onSubmit(card) {
      if (this.player === null && this.$refs.video) {
        this.player = videojs(this.$refs.video, {
          autoplay: false,
          controls: false,
          preload: true,
          fill: true,
          loop: true,
          sources: [
            {
              src: '/fotos/MUSIC.mp4',
              type: 'video/mp4'
            }
          ]
        });
      }
      if(card.item.id=='TZ'){
        this.player.play();
      }
      if(card.item.id=='MUSIC'){
        this.player.pause();
        this.player = null;
      }
      if (card.type == 'nope') {
        this.queue = [OHNO, INFO];
        return;
      }
      if (card.type == 'info') {
        this.queue = [this.queue[this.queue.findIndex(x => x.id === 'INFO')]];
        return;
      }
    },


    async decide(choice) {
      if (this.queue[0].final && (choice === 'nope' || choice === 'like')) {
        return;
      }
      if (this.queue[0].id == 'INFO' && choice === 'info') {
        return;
      }
      if (choice === "info") {
        this.$refs.tinder.decide('info');
        return
      }
      if (choice === "rewind") {
        this.populate();
        return;
      }
      this.$refs.tinder.decide(choice);
    },

    signup() {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSclefr-BB3PuaYyw_HxybXty0U7f7TvwaOvsVrgDZodvvzocQ/viewform');
    }
  }
};
</script>

<style>
html,
body {
  height: 100%;
  font-family: 'Arial', sans-serif;
  font-size: 15px;
}

body {
  margin: 0;
  background-color: #efefef;
  background-image: url("./assets/bg.png");
  background-size: cover;
  overflow: hidden;
  letter-spacing: .04rem;
}

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.container {
  height: 90%;
  max-height: 1000px;
  min-height: 600px;
  aspect-ratio: 9/16;
  display: flex;
  flex-direction: column;
}

.vue-tinder {
  height: 100%;
  width: 100%;
  margin-bottom: 3rem;
  flex-grow: 1;
}


.pic-wrapper {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.pic-wrapper:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background: linear-gradient(to bottom, transparent 60%, rgba(0, 0, 0, 0.85) 80%, rgba(0, 0, 0, 0.9) 100%);
}

.card-text-wrapper {
  display: flex;
  align-items: flex-end;
  z-index: 99;
}

.card-text {
  color: white;
  padding: 0 1.2rem 1.2rem 1.2rem;
  text-shadow: black 0px 0px 3px;
}

h1,
h2 {
  padding: 0 0 0.3rem 0;
  margin: 0;
  font-size: 1.5rem;
}

h2 {
  font-size: 1.10rem;
  font-weight: normal;
  padding-bottom: 0.3rem;
}

.text {
  line-height: 1.3em;
}

.btns-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.btns {
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  width: 19rem;
}

.btns img {
  box-shadow: 0 4px 9px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(3, 3, 3, 0.03);

}

.hidden {
  opacity: 0.4;
}


.btns .small {
  width: 3rem;
}

.btns .big {
  width: 4rem;
}

.btns img:nth-last-child(1) {
  margin-right: 0;
}

.infobox {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  color: #444;
}

.infobox .info {
  flex-grow: 1;
  padding: 0 2rem 2rem 2rem;
}

.infobox .signup {
  padding: 1.5rem;
  text-align: center;
  border-radius: 10px;
  line-height: 1.2rem;
  background: linear-gradient(to right top, #7ee4d3, #02be6b);
  color: white;
  font-size: 1.5rem;
  cursor: pointer !important;
}

.inforow {
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;

}

.inforow div {
  margin-left: 1.5rem;
  font-size: 1.2rem;
}

.inforow .secondline {
  font-size: 1rem;
}

.infobox h3 {
  font-size: 2rem;
  margin-bottom: 1.8rem;
}
</style>
